import { usePartnerData } from '@/shared/access';

export const useMePartner = () => {
  return usePartnerData();
};

export const useMePartnerSelector = () => {
  return usePartnerData();
};
